<template>
    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
        <el-button type="primary" @click="addFragment">新增</el-button>
        <div class="table-wrapper">
            <el-table :data="cardFragmentStore.fragments" v-loading="loading" style="width: 100%">
                <el-table-column fixed prop="id" label="ID" width="200">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="viewFragment(scope.row.id)">{{ scope.row.id
                        }}</el-link>
                        <CopyButton :text="scope.row.id" />
                    </template>
                </el-table-column>
                <el-table-column fixed prop="image" label="Image" width="100">
                    <template #default="scope">
                        <img v-if="!!scope.row.image" class="table-image" :src="scope.row.image" alt="image"
                            loading="lazy" @click="openPreview(scope.row.index)" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="Name" width="160">
                    <template #default="scope">
                        {{ scope.row.name }}
                        <CopyButton :text="scope.row.name" />
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="排序值" width="80" />
                <el-table-column fixed="right" label="操作" min-width="120">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="viewFragment(scope.row.id)">详情</el-link>
                        <el-divider direction="vertical" />
                        <el-link underline="always" type="primary" @click="editFragment(scope.row.id)">编辑</el-link>
                    </template>
                </el-table-column>
            </el-table>
            <el-image-viewer v-if="showPreview" :url-list="cardFragmentStore.fragments.map(row => row.image)"
                :initial-index="previewIndex" @close="showPreview = false" :hide-on-click-modal="true" />
        </div>
    </el-card>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRouter } from 'vue-router';
import { useCardFragmentStore } from "@/stores/card/fragment";

const cardFragmentStore = useCardFragmentStore();

const router = useRouter();

const loading = ref(false);

const showPreview = ref(false);
const previewIndex = ref(0);

const openPreview = (index) => {
    previewIndex.value = index;
    showPreview.value = true;
}

function addFragment() {
    router.push(`/fragment/add`);
}

function viewFragment(id) {
    router.push(`/fragment/${id}`);
}

function editFragment(id) {
    router.push(`/fragment/edit/${id}`);
}

async function loadData() {
    loading.value = true;

    const response = await cardFragmentStore.getAll();
    if (!response) {
        return false;
    }

    loading.value = false;
}

onMounted(async () => {
    await loadData();
});
</script>

<style scoped>
.table-image {
    width: 60px;
    height: 90px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #e5e5e5;
}
</style>
